// Auto-generated by set-version.js — do not edit
export const appVersion = '1.2.04-996aff2a-2026-06-06';
